import Library    from './customers/library/library.vue';
import Search     from './customers/search/search.vue';
import Shows      from './customers/shows/shows.vue';

import ClipMaker  from './customers/customers-clip-maker/customers-clip-maker.vue';
import Carts      from './customers/carts/carts.vue';
import CartInfo   from './customers/cart-info/cart-info.vue';

export default Object.freeze([
   {
      path     : '/library',
      name     : 'Shows',
      component: Shows,
      children : [
         {
            path     : ':mid',
            name     : 'Library',
            component: Library,
            children: [
               {
                  path     : 'search',
                  name     : 'Search',
                  component: Search
               },
               {
                  path     : 'carts',
                  name     : 'Carts',
                  component: Carts
               },
               {
                  path     : 'carts/:cid',
                  name     : 'CartInfo',
                  component: CartInfo
               },
               {
                  path     : ':eid',
                  name     : 'ClipMaker',
                  component: ClipMaker
               }
            ]
         }
      ]
   },
   {
      path     : '*',
      name     : '404',
      redirect : { name: 'Shows' }
   }
]);
